import { render, staticRenderFns } from "./MspTabellaRecord.vue?vue&type=template&id=09679edb"
import script from "./MspTabellaRecord.vue?vue&type=script&lang=js"
export * from "./MspTabellaRecord.vue?vue&type=script&lang=js"
import style0 from "./MspTabellaRecord.vue?vue&type=style&index=0&id=09679edb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports